<app-breadcrumbs type="pricing"></app-breadcrumbs>

<div class="pricing-page">
  <!-- Hero -->
  <div class="pricing-hero">
    <h1 class="pricing-title">Choose Your Plan</h1>
    <p class="pricing-subtitle">Unlock powerful audience insights and grow with confidence</p>
  </div>

  <!-- Package Tabs -->
  <div class="package-tabs" *ngIf="packageCountSteps.length > 1">
    <button
      *ngFor="let c of packageCountSteps"
      class="tab-btn"
      [class.active]="packageCount === c"
      (click)="setPackageCount(c)"
    >Package {{c}}</button>
  </div>

  <!-- Loader -->
  <app-loader *ngIf="packageCountSteps.length === 0" message="Loading plans..."></app-loader>

  <!-- Price Cards -->
  <div class="price-cards-row" *ngIf="(paymentState | async).pricingTime[packageCount] !== undefined && (paymentState | async).pricingTime[packageCount][followersSlider] !== undefined">
    <div
      *ngFor="let price of (paymentState | async).pricingTime[packageCount][followersSlider]"
      class="price-card-col"
      [class.hidden-card]="!((userState | async).user !== null
        && ((userState | async).user.type !== 1
          || (
            (userState | async).user.type === 1
            && (price.permissions['auditor.limit'].followers_count === undefined
                || price.permissions['auditor.limit'].followers_count === -1
                || (price.permissions['auditor.limit'].followers_count > 0
                    && followersSlider === price.permissions['auditor.limit'].followers_count
                    && ((profileState | async).profileDetail === null
                      || ((profileState | async).profileDetail !== null
                          && (
                            (profileState | async).profileDetail.followed_by < price.permissions['auditor.limit'].followers_count
                              || (profileState | async).profileDetail.demo !== undefined)
                          )
                    )
                    )
                )
            )
        )
      )"
    >
      <app-price-box
        *ngIf="(userState | async).user !== null
          && ((userState | async).user.type !== 1
            || (
              (userState | async).user.type === 1
              && (price.permissions['auditor.limit'].followers_count === undefined
                  || price.permissions['auditor.limit'].followers_count === -1
                  || (price.permissions['auditor.limit'].followers_count > 0
                      && followersSlider === price.permissions['auditor.limit'].followers_count
                      && ((profileState | async).profileDetail === null
                        || ((profileState | async).profileDetail !== null
                            && (
                              (profileState | async).profileDetail.followed_by < price.permissions['auditor.limit'].followers_count
                                || (profileState | async).profileDetail.demo !== undefined)
                            )
                      )
                      )
                  )
              )
          )"
        [price]="price"
      ></app-price-box>
    </div>
  </div>

  <!-- Trust Signals -->
  <div class="trust-section">
    <p class="cancel-note">
      <i class="bi bi-shield-check"></i>
      Cancel anytime &mdash; no questions asked
    </p>
    <div class="trust-badges">
      <span class="trust-item"><i class="bi bi-lock-fill"></i> Secure payment</span>
      <span class="trust-item"><i class="bi bi-credit-card"></i> Powered by Stripe</span>
      <span class="trust-item"><i class="bi bi-arrow-repeat"></i> Instant access</span>
    </div>
  </div>
</div>